import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ParentsPage() {
  return <InstituteCrudPage config={entityConfigs['parents']} />;
}
